import axios from 'axios'
import { API_BASE_URL } from '@/config/api'
import { clearAuthStorage } from '@/utils/authStorage'

const api = axios.create({
  baseURL: API_BASE_URL
})

// Agrega el token automáticamente a todas las peticiones
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token')

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

// Si el token expira, redirige al login
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      clearAuthStorage()
      window.location.href = '/'
    }

    return Promise.reject(error)
  }
)

export default api